import React, { useEffect, useState, createContext, useCallback } from 'react';
import { Provider } from 'react-redux';
import { Route, Switch, BrowserRouter } from 'react-router-dom';
import store from 'store';
import { PublicRoutes, PrivateRoutes } from './routes';
import { ToastContainer } from 'react-toastify';

import 'react-datepicker/dist/react-datepicker.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-toastify/dist/ReactToastify.css';
import './style.scss';
import './app.scss';

import PageNotFound from 'components/Error/PageNotFound';
import Params from 'helpers/Params';
import LoginService from 'services/login';
import { MasterAgentProfiles } from 'helpers/Enum';
import Loading from '../components/Loading';
import MasterPage from "components/MasterPage";
import { User } from 'models/user';
import { registerLocale } from 'react-datepicker';
import ptBR from "date-fns/locale/pt-BR";
import Storage from 'helpers/storage';
import AccessionForm from './AccessionForm';
import swal from 'helpers/swal';
import DocumentService from 'services/document';
import { Card, Col, Row } from 'react-bootstrap';
import { event } from 'jquery';
import Maintenance from './Maintenance';

registerLocale("pt-BR", ptBR);

const App = () => {
  const email = "elitepass@scansource.com"
  const [appConfig, setAppConfig] = useState(() => {
    if (localStorage.getItem("Elite:appConfig"))
      return JSON.parse(localStorage.getItem("Elite:appConfig"))
    else
      return null
  })

  const date = new Date();
  const [user, setUser] = useState(null);
  const [company, __setCompany] = useState(() => {
    let c = Storage.getObject("company")
    if (!c) return null
    return c
  });

  const [userLoad, setUserLoad] = useState(true);
  const [token, setToken] = useState(Storage.get("token"));
  const [permissions, setPermissions] = useState([]);
  const [collapsed, setCollapsed] = useState(false);
  const [fiscalYears, setFiscalYears] = useState([])

  const [_, setDocumentUri] = useState('')

  const [autoLogin] = useState(Params.get('t-al'));

  const setCompany = useCallback((company, save = true) => {
    if (save) {
      Storage.setTempObject("user", user)
    }
    if (!!company && save) {
      Storage.setObject("company", company)
    } else {
      Storage.remove("company")
    }
    setUserLoad(true);
    __setCompany(company);
  }, [user])

  // useEffect(() => {
  //   const handleError = () => {
  //     console.error("error: ", event.message)
  //     localStorage.clear()
  //   }

  //   window.addEventListener('error', handleError)

  //   return () => {
  //     window.removeEventListener('error', handleError)
  //   }
  // },[])

  useEffect(() => {
    if (!!autoLogin) {
      LoginService.autoLogin(autoLogin).then((response) => {
        localStorage.clear();
        let info = response.data;
        info = info.data;
        Storage.set('token', info.access_token);
        window.location.href = window.location.href.split('?')[0];
      }).catch(() => {
        window.location.href = "/"
      });
    } else if (!!token) {
      let user_temp = Storage.getObject("user");
      if (user_temp) {
        let user = User.assign(user_temp);
        if (user.companies) {
          const companies = user.companies.filter(c => c.company_type_id == 2)
          if (companies.length == 1) {
            setCompany(companies[0], false)
          }
        }
        setPermissions(user.profile.routes.map(a => a.alias))
        setUser(user)
        setUserLoad(false)
      } else {
        LoginService.get_auth()
          .then(({ data }) => {
            setAppConfig({ ...data.app_config })
            localStorage.setItem("Elite:appConfig", JSON.stringify(data.app_config))

            if (![1, 48, ...MasterAgentProfiles].includes(data.user.profile.id)) {
              getContract()
            }
            data.user.can_make_adhesion = data.can_make_adhesion
            data.user.company_blocked = false;
            let user = new User(data.user)
            user.setCurrentDate(data.current_date)
            user.setListYears(data.fiscal_year)
            if (data.user.companies && data.user.companies.length == 1) {
              if (data.user.companies[0]?.headquarter == 0 && !localStorage.getItem('Elite:fiscalYear')) {
                const years = data.user.companies[0].fiscal_year.filter(year => !year.block)
                localStorage.setItem('Elite:fiscalYear', JSON.stringify(years[0]))
              }
              const [first] = data.user.companies

              if (first.adhesion) {
                setFiscalYears(first.adhesion.filter(a => a.fiscal_year.block == 0 && (data.company_blocked?data.company_blocked:[]).indexOf(a.fiscal_year_id) == -1))
                data.user.company_blocked = first.adhesion.filter(a => {
                  return a.fiscal_year.block == 0 && (data.company_blocked?data.company_blocked:[]).indexOf(a.fiscal_year_id) == -1
                }).length == 0;
                first.adhesion = first.adhesion.filter(a => {
                  return (data.company_blocked?data.company_blocked:[]).indexOf(a.fiscal_year_id) == -1;
                })
              } else {
                setFiscalYears(first.fiscal_year.filter(a => a.block == 0 && (data.company_blocked?data.company_blocked:[]).indexOf(a.id) == -1))
              }
              setCompany(first, false)
            }

            setPermissions(user.profile.routes.map(a => a.alias))
            setUser(user)
            setUserLoad(false)
          }).catch((e) => {
            console.log(e)
            if (e.response) {
              localStorage.clear()
              setUserLoad(false)
              setToken(null)
            }
          })
      }
    } else {
      setUserLoad(false)
    }
  }, [token, autoLogin]);

  function getContract() {
    DocumentService.getContract()
      .then(r => {
        setDocumentUri(r.data.document_url)
      })
  }

  const logout = async () => {
    try {
      await LoginService.logout();
    } catch (error) {
    } finally {
      localStorage.clear();
      window.location.reload();
    }
  };

  const handleClickFiscalYear = async (fy) => {

    if (!!fy.block) {
      swal.warning("Aguarde até que o acesso seja liberado.")
      return
    }

    await new Promise((resolve) => {
      localStorage.setItem("Elite:fiscalYear", JSON.stringify(fy))
      resolve(true)
    })

    window.location.reload()
  }

  if ((userLoad && !!token) || autoLogin) {
    return <Loading />
  }

  if ((user && ![48, ...MasterAgentProfiles].includes(user.profile.id)) && appConfig?.in_maintenance_mode == 1) {
    return (
      <Provider store={store}>
        <AppDataContext.Provider value={{
          user, company, setCompany
        }}>
          <BrowserRouter>
            <Route path="/" component={Maintenance} />
          </BrowserRouter>
        </AppDataContext.Provider>
      </Provider>
    )
  }

  if (!user) {
    return (
      <Provider store={store}>
        <BrowserRouter>
          <Switch>
            {PublicRoutes.map((route, k) => (
              <Route
                key={k}
                exact={!!route.exact}
                path={route.pathname}
                component={route.component}
                {...route.props}
              />
            ))}
            <Route
              path="/"
              component={() => {
                window.location.href = '/'
                return <Loading />
              }}
            />
          </Switch>
        </BrowserRouter>
      </Provider>
    )
  }

  if (![1, 2, 3, 9, 10, 11, 14, 38, 48, 50, ...MasterAgentProfiles].includes(user.profile.id)) { //[4].includes(user.profile.id)
    if (!company) {
      swal.adhesionWarning(
        "",
        'warning',
        'Olá!',
        `
          <p>
            O novo portal ainda não está disponível.
          </p>
          <p>
            Em caso de dúvidas, fique à vontade para entrar em contato conosco pelo 
            e-mail <a href='mailto:${email}'>${email}</a>.
          </p>
        `
      ).then((result) => {
        if (result.isConfirmed) {
          logout();
        }
      })
      return <></>;
    }

    if (!company.adhesion.length) {
      swal.adhesionWarning(
        "",
        'warning',
        'Ops!',
        `
          <p>Acesso Indisponível</p>
          <p>Para mais informações entrar em contato em <a href='mailto:${email}'>${email}</a></p>
        `
      ).then((result) => {
        if (result.isConfirmed) {
          logout();
        }
      })
      return <></>;
    }

    // let fiscal_year = "2025";
    // try {
    //   fiscal_year = user.fiscal_years.fiscal_year
    // } catch (error) {
      
    // }
    //console.log(user.fiscal_years[user.fiscal_years.length - 1])

    let current_fiscal_year = user.fiscal_years[user.fiscal_years.length - 1];
    if (!user.can_make_adhesion && (company.adhesion && !company.adhesion[0]?.date_accept)) {
      swal.adhesionWarning(
        "",
        'warning',
        'Ops!',
        `
          <p>Olá!</p>
          <p>
            A revenda da qual faz parte ainda não realizou a adesão para o ano fiscal ${current_fiscal_year.fiscal_year}. 
            Mas fique tranquilo, assim que a adesão for realizada, você receberá por e-mail todas as instruções para o acesso.
          </p>
          <p>
            Em caso de dúvidas, fique à vontade para entrar em contato conosco pelo 
            e-mail <a href='mailto:${email}'>${email}</a>.
          </p>
        `
      ).then((result) => {
        if (result.isConfirmed) {
          logout();
        }
      })
      return <></>;
    }

    if (user.company_blocked) {
      return (
        <Row>
          <Col md="12" className='d-flex justify-content-center align-items-center'>
            <div className='text-center mt-5'>
              <span className='h3' style={{ color: "#e3e3e3" }}>Acesso Indisponível!</span>
            </div>
          </Col>
          <Col md="12" className='d-flex justify-content-center mt-2'>
            <a className='fy-logout-btn' role='button' onClick={logout}> Sair</a>
          </Col>
        </Row>
      );
    }

    if (company.adhesion && company.adhesion[0]?.date_accept) {
      if (!localStorage.getItem('Elite:fiscalYear')) {
        return (
          <div
            style={{
              marginLeft: 0,
              backgroundImage: 'linear-gradient(to right, #2F2B6C, #FBAF43)'
            }}
            className='vh-100 vw-100 d-flex align-items-center justify-content-center flex-column'
          >
            <div className='text-center' style={{ color: 'white' }}>
              {fiscalYears.length == 0 ? (
                <h1 style={{ color: 'white' }}>Acesso Indisponível</h1>
              ) : <span style={{ fontSize: '25px' }}>Selecione o ano Fiscal</span>}
            </div>
            <Row className='d-flex justify-content-center'>
              {/*[...company.adhesion]*/ fiscalYears.map(item => (
                <Col
                  disabled
                  role="button"
                  key={item.fiscal_year.id}
                  md={(company.adhesion.length + 1) / 12}
                  className='mr-3 fiscal-year-selection-item'
                  onClick={() => handleClickFiscalYear(item.fiscal_year)}
                >
                  <Card.Body className={`fiscal-year-selection-item-body shadow bg-white rounded m-2 col-12 text-center ${item.fiscal_year.block ? 'fiscal-year-disabled' : ''}`}>
                    <span className='h3'>{item.fiscal_year.fiscal_year}</span><br />
                    {item.fiscal_year.block ? (
                      <span>Não disponível</span>
                    ) : (<>
                      <span>Jul/{item.fiscal_year.fiscal_year - 1} - Jun/{item.fiscal_year.fiscal_year}</span>
                    </>)}
                  </Card.Body>
                </Col>
              ))}
              <Col md="12" className='d-flex justify-content-center mt-2'>
                <a className='fy-logout-btn' role='button' onClick={logout}>Sair</a>
              </Col>
            </Row>
          </div>
        )
      }
      // swal.adhesionWarning(
      //   "",
      //   'success',
      //   'Olá!',
      //   `
      //     <div>
      //       <p>
      //         Obrigada por se inscrever no <strong>Programa ScanCash 2025</strong> da ScanSource!
      //       </p>
      //       <p>
      //         Em breve, disponibilizaremos seu acesso ao novo portal e você receberá as instruções neste e-mail. 
      //         Por enquanto, aproveite para acessar nossos materiais e ficar por dentro de todas as novidades deste novo programa!
      //       </p>

      //       <div style="display: flex;justify-content: space-between;margin-bottom:30px;">
      //         <a class="btn btn-primary" href='#' target='_blank'>Apresentação do Programa</a>
      //         <a class="btn btn-primary" href='${documentUri}' target='_blank'>Regulamento Scancash FY24</a>
      //       </div>

      //       <p>
      //         Em caso de dúvidas, fique à vontade para entrar em contato conosco pelo e-mail 
      //         <a href='mailto:elitepass@scansource.com'>elitepass@scansource.com</a>.
      //       </p>
      //     </div>
      //   `
      // ).then((result) => {
      //   if (result.isConfirmed) {
      //     logout();
      //   }
      // })
    }

    if (user.can_make_adhesion && company.adhesion && !company.adhesion[0]?.date_accept) {
      return (
        <Provider store={store}>
          <AppDataContext.Provider value={{
            user, company, setCompany
          }}>
            <BrowserRouter>
              <Route path="/" component={AccessionForm} />
            </BrowserRouter>
          </AppDataContext.Provider>
        </Provider>
      )
    }
  }

  return (
    <Provider store={store}>
      <AppDataContext.Provider value={{
        user, company, setCompany
      }}>
        <BrowserRouter>
          <ToastContainer />
          <MasterPage setCollapsed={setCollapsed} collapsed={collapsed}>
            <Switch>
              {PrivateRoutes.filter((item) => {
                if (item.permission) return permissions.indexOf(item.permission) !== -1;
                return false
              }).map((route, k) => {
                return (
                  <Route
                    key={k}
                    exact
                    path={route.pathname}
                    component={route.component}
                  />
                );
              })}
              <Route
                path={"/"}
                component={PageNotFound}
              />
            </Switch>
          </MasterPage>
        </BrowserRouter>
      </AppDataContext.Provider>
    </Provider>
  );
};

const AppDataContext = createContext({
  user: null,
  company: null,
  setCompany: () => { },
});

export { AppDataContext };

export default App;
